import React, {FunctionComponent, useState} from 'react';
import HanButton from '../../../utils/HanButton';
import WhitelistUser from '../../../../networking/models/WhitelistUser';
import EditCard from '../../layout/EditCard';
import WhitelistCard from '../../partials/whitelist/WhitelistCard';
import {toast} from 'react-toastify';
import {useWhitelistDeleteMutation, useWhitelistSaveMutation} from '../../../query/Whitelist/Mutation';

interface NewUser {
    number: number;
}

interface Props {
    whitelist: WhitelistUser[];
}

const WhitelistContent: FunctionComponent<Props> = (props) => {

    const whitelistSaveMutation = useWhitelistSaveMutation();
    const whitelistDeleteMutation = useWhitelistDeleteMutation();

    const [newUsers, setNewUsers] = useState<NewUser[]>([]);

    const addUser = () => {
        setNewUsers([...newUsers, { number: Math.random() }]);
    };

    const onNewUserSave = async (email: string, number: number) => {
        await saveWhitelistUser({ email });
        deleteNewUser(number);
    };

    const onNewUserDelete = (number: number) => {
        deleteNewUser(number);
    };

    const deleteNewUser = (number: number) => {
        const newState = [...newUsers];

        const index = newState.findIndex(u => u.number === number);
        newState.splice(index, 1);

        setNewUsers(newState);
    };

    const saveWhitelistUser = async (user: WhitelistUser) => {
        toast.promise(whitelistSaveMutation.mutateAsync(user), {
            pending: `Saving ${user.email}`,
            success: `Saved ${user.email}!`,
            error: `Error updating whitelist!`
        });
    };

    const deleteWhiteListUser = async (user: WhitelistUser) => {
        await toast.promise(whitelistDeleteMutation.mutateAsync(user), {
            pending: `Deleting ${user.email}`,
            success: `Deleted ${user.email}!`,
            error: `Error updating whitelist!`
        });
    };

    return (
        <>
            <h1 className={'admin-whitelist-page__title'}>Whitelist</h1>

            <HanButton onClick={addUser}>Add HAN Account</HanButton>

            <div className={'admin-whitelist-page__accounts'}>
                { newUsers.map(newUser => (
                    <EditCard
                        value={''}
                        open={true}
                        onChange={(email) => onNewUserSave(email, newUser.number)}
                        onDelete={() => onNewUserDelete(newUser.number)}
                        key={newUser.number} />
                )) }

                { props.whitelist.map(user => (
                    <WhitelistCard
                        user={user}
                        onChange={user => saveWhitelistUser(user)}
                        onDelete={deleteWhiteListUser}
                        key={user.id} />
                )) }
            </div>
        </>
    );
};

export default WhitelistContent;
